const viewAction = {
    ADD_ITEM_TO_SCHEMA: 'ADD_ITEM_TO_SCHEMA',
    UPDATE_SECTION_SCHEMA: 'UPDATE_SECTION_SCHEMA',
    UPDATE_UI_SCHEMA: 'UPDATE_UI_SCHEMA',
    ADD_UI_SCHEMA: 'ADD_UI_SCHEMA',
    DELETE_SECTION_SCHEMA: 'DELETE_SECTION_SCHEMA',
    ADD_FIELD_SCHEMA: 'ADD_FIELD_SCHEMA',
    UPDATE_FIELD_SCHEMA: 'UPDATE_FIELD_SCHEMA',
    RESET_VIEW: 'RESET_VIEW',
    ADD_VIEW: 'ADD_VIEW',
    EDIT_VIEW: 'EDIT_VIEW',
    DELETE_VIEW: 'DELETE_VIEW',
    UPDATE_COMPLETE_VIEWS: 'UPDATE_COMPLETE_VIEWS',
    UPDATE_FULL_VIEWS: 'UPDATE_FULL_VIEWS',
    SET_VIEW: 'SET_VIEW',
    SET_VIEW_INTERRUPT: "SET_VIEW_INTERRUPT"
}

export default viewAction;